var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpicon = function SvgArrowUpicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.4 16h-.8a.4.4 0 0 1-.4-.4V2.664l-3.552 3.56a.4.4 0 0 1-.568 0l-.56-.568a.4.4 0 0 1 0-.568L7.424.176A.6.6 0 0 1 7.848 0h.304c.159.002.31.065.424.176l4.904 4.912a.4.4 0 0 1 0 .568l-.568.568a.392.392 0 0 1-.56 0L8.8 2.664V15.6a.4.4 0 0 1-.4.4Z"
  })));
};
export default SvgArrowUpicon;